import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import UserService from "../../services/user.service";
import moment from "moment";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css"; // Import styles
import "react-calendar/dist/Calendar.css"; // Required for calendar display
import Loading from "../../common/Loading";
import { customStyles, customStylesError } from "../../common/CustomStyles";

const TasksAdd = (props) => {
  let history = useHistory();
  const myRef = useRef(null);
  const [familyDetails, setFamilyDetails] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [userCreateUpdate, setUserCreateUpdate] = useState();
  const [userCreateUpdateFor, setUserCreateUpdateFor] = useState();
  const [selectedTenure, setSelectedTenure] = useState();
  const [taskUrl, setTaskUrl] = useState("");
  const [backText, setBackText] = useState("Back to My To Do's");
  const executeScroll = () => myRef.current.scrollIntoView();
  const onSwitchAction = () => {
    setIsSwitchOn(!isSwitchOn);
  };
  const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));

  const initialValues = {
    task_name: "",
    task_details: "",
    eta_date: "",
    task_frequency: "",
    assignee: "",
    endDate: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [selectedAssignee, setSelectedAssignee] = useState({
    value: "",
    label: "Select an assignee",
  });

  const initialFrequencyOption = [
    { value: "Daily", label: "Daily" },
    { value: "Weekly", label: "Weekly" },
    { value: "Monthly", label: "Monthly" },
    { value: "Quarterly", label: "Quarterly" },
    { value: "Bi-Annually", label: "Bi-Annually" },
    { value: "Yearly", label: "Yearly" },
  ];
  const [frequencyOption, setFrequencyOption] = useState(
    initialFrequencyOption
  );

  const initialAssigneeOption = [{ value: "", label: "Select an assignee" }];
  const [assigneeOption, setAssigneeOption] = useState(initialAssigneeOption);
  let { uuid, userUUID } = useParams();

  var userType = localStorage.getItem("userType");

  const [Loadingdata, setLoadingdata] = useState(true);
  const [dateValStart, setDateValStart] = useState(); // Default start date
  const [dateValEnd, setDateValEnd] = useState(); // Default start date
  const [mounted, setMounted] = useState(false); // Default selected date

  const handleChange = (e, action) => {
    let targetData = {};
    if (action) {
      if (action.name === "assignee") {
        setSelectedAssignee(e);
      }
      if (action.name === "task_frequency") {
        setSelectedTenure(e);
      }
      targetData = {
        name: action.name,
        value: e.value,
      };
    } else {
      targetData = {
        name: e.target.name,
        value: e.target.value,
      };
    }
    const { name, value } = targetData;
    setFormValues({ ...formValues, [name]: value });
  };

  // handle submit
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate the form and get the errors immediately
    const errors = validate(formValues);

    // Update the form errors state
    setFormErrors(errors);

    // Set other states
    setIsSubmit(true);
    setLoading(true);

    // Log errors immediately after validation

    // Call your submit handler
    submitBtn(Object.keys(errors).length);
  };
  // validation
  const validate = (values) => {
    const errors = {};
    if (!values.task_name) {
      errors.msg = "Please enter the to do name";
      errors.task_name = "Yes";
    }
    if (!values.eta_date) {
      errors.msg = "Please enter the date";
      errors.eta_date = "Yes";
    }
    if (!selectedAssignee.value) {
      errors.msg = "Please enter the assignee";
      errors.assignee = "Yes";
    }
    if (isSwitchOn && !values.task_frequency) {
      errors.msg = "Please enter the activity frequency";
      errors.task_frequency = "Yes";
    }
    if (isSwitchOn && !values.endDate) {
      errors.msg = "Please enter the number of occurrences";
      errors.endDate = "Yes";
    }
    return errors;
  };

  const getFamilyDetails = (userId) => {
    // get family details
    UserService.getUserSingleFamilyDetails(uuid, userId).then(
      (response) => {
        setFamilyDetails(response);
        setUserCreateUpdateFor(response.FamilyData.id);

        // SU Family details
        UserService.getUserSingleFamilyDetails(uuid, UserDetails.id).then(
          (suResponse) => {
            setUserCreateUpdate(suResponse.FamilyData.UserId);
            // get list of Su user
            UserService.getOnBoardedFamilyUserList(uuid, userId, "AU").then(
              (userlistres) => {
                if (
                  userType === "AO + AU" ||
                  userType === "AO + AU + SU" ||
                  userType === "AU" ||
                  userType === "AU + SU"
                ) {
                  const optionArr = [
                    { value: suResponse.FamilyData.id, label: "Self" },
                  ];

                  if (userlistres.usersData.length !== 0) {
                    for (var i = 0; i < userlistres.usersData.length; i++) {
                      if (userlistres.usersData[i].Family_User.isAu === true) {
                        optionArr.push({
                          value: response.FamilyData.id,
                          label: "To Main user",
                        });
                      }
                    }

                    setAssigneeOption(optionArr);
                  } else {
                    setAssigneeOption(optionArr);
                  }
                } else if (userType === "SU" || userType === "AO + SU") {
                  const optionArr = [
                    { value: suResponse.FamilyData.id, label: "Self" },
                    { value: response.FamilyData.id, label: "To Main user" },
                  ];
                  setAssigneeOption(optionArr);
                }
              }
            );
          },
          (error) => {}
        );
      },
      (error) => {}
    );
  };

  const getAUFamilyDetails = (userId) => {
    UserService.getUserSingleFamilyDetails(uuid, userId).then(
      (response) => {
        setFamilyDetails(response);
        setUserCreateUpdate(response.FamilyData.UserId);
        setUserCreateUpdateFor(response.FamilyData.id);

        // get list of Su user
        UserService.getOnBoardedFamilyUserList(uuid, userId, "AU").then(
          (userlistres) => {
            if (
              userType === "AO + AU" ||
              userType === "AO + AU + SU" ||
              userType === "AU" ||
              userType === "AU + SU"
            ) {
              var arr1 = [{ value: response.FamilyData.id, label: "Self" }];
              var arr2 = [];

              if (userlistres.usersData.length !== 0) {
                userlistres.usersData.map((v, index) =>
                  v.Family_User.inviteStatus !== "Removed"
                    ? arr2.push({
                        value: v.FamilyUserId,
                        label:
                          v.Family_User.User.firstName === "null"
                            ? v.Family_User.User.email
                            : v.Family_User.User.firstName +
                              " " +
                              v.Family_User.User.lastName,
                      })
                    : ""
                );
                var optionArr = [...arr1, ...arr2];

                setAssigneeOption(optionArr);
              } else {
                setAssigneeOption(arr1);
              }
            }
          }
        );
      },
      (error) => {}
    );
  };

  const [familyUserId, setFamilyUserId] = useState();
  const [timeZone, setTimeZone] = useState(0);

  useEffect(() => {
    const offsetInMinutes = new Date().getTimezoneOffset();
    setTimeZone(offsetInMinutes);
    setTimeout(() => {
      setLoadingdata(false);
      setMounted(true);
    }, 500);
  }, []);

  useEffect(() => {
    UserService.relationData(uuid).then((response) => {
      // main user checking
      const mainUser = response.data.au.find(
        (obj) => obj.User.email === UserDetails.email
      );

      const mainArr = [];
      if (mainUser) {
        mainArr.push(mainUser);
      }

      // support user checking
      const suppUser = response.data.au.find((obj) =>
        obj.su.find(
          (family) =>
            family.Family_User &&
            family.Family_User.User.email === UserDetails.email
        )
      );

      const suppArr = [];
      if (suppUser) {
        suppArr.push(suppUser);
      }

      let newArray = [];
      newArray = [...mainArr, ...suppArr];
      const uuidFind = newArray.find((obj) => obj.User.uuid === userUUID);

      userUUID && setFamilyUserId(uuidFind.id);
    });

    if (userUUID) {
      UserService.userProfile(userUUID).then((response) => {
        getFamilyDetails(response.userData.id);
        setTaskUrl("/user_todos/" + uuid + "/" + userUUID);
        setBackText(
          response.userData.firstName === "null"
            ? response.userData.email
            : response.userData.firstName + " " + response.userData.lastName ===
              "null"
            ? ""
            : response.userData.firstName
        );
      });
    } else {
      getAUFamilyDetails(UserDetails.id);
      setTaskUrl("/todos/" + uuid);
    }

    // add task
  }, [formErrors]);

  function keepSameDateTimeInUTC(dateString) {
    let date = new Date(dateString); // Create Date object
    date.setMinutes(date.getMinutes() - timeZone); // 5 hours 30 minutes = 330 minutes (UTC)
    return date;
  }

  console.log(formValues.endDate);

  const submitBtn = (length) => {
    if (length === 0) {
      setLoading(true);

      let data = {
        name: formValues.task_name,
        details: formValues.task_details,
        eta: formValues.eta_date
          ? keepSameDateTimeInUTC(formValues.eta_date)
          : null,
        taskRecurrence: isSwitchOn ? true : false,
        taskFrequency: formValues.task_frequency
          ? formValues.task_frequency
          : null,
        endDate: formValues.endDate ? formValues.endDate : null,
        assigneeId: selectedAssignee.value, //FamilyUser's Id give
        updatedBy: userCreateUpdate,
        FamilyId: familyDetails.FamilyData.FamilyId,
        FamilyUserId: userUUID ? familyUserId : familyDetails.FamilyData.id,
        createdBy: userCreateUpdate,
      };

      console.log(data);

      if (
        isSwitchOn === true &&
        (formValues.task_frequency === "" || formValues.endDate === "")
      ) {
        setLoading(false);
        setSuccessToast(false);
        setShowToast(true);
        executeScroll();
        window.scrollTo(0, 0);
        setToastMessage("Please fill Activity Reccurency field");
      } else {
        // api call
        UserService.createTask(data).then(
          (response) => {
            if (response.status === 200 || response.status === 201) {
              setLoading(false);
              setSuccessToast(true);
              setShowToast(true);
              executeScroll();
              window.scrollTo(0, 0);
              setToastMessage("To Do created successfully");
              setTimeout(() => {
                history.push(taskUrl);
              }, 2000);
            } else {
              setLoading(false);
              setSuccessToast(false);
              setShowToast(true);
              executeScroll();
              window.scrollTo(0, 0);
              setToastMessage("Error !");
            }
          },
          (error) => {}
        );
        // end api call
        setFrequencyOption(initialFrequencyOption);
        // setIsSwitchOn(true);
      }
    } else {
      setLoading(false);
      // window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    if (mounted) {
      if (dateValStart) {
        setFormValues((prevValues) => ({
          ...prevValues,
          eta_date: dateValStart,
        }));
        setFormErrors((prevErrors) => ({ ...prevErrors, eta_date: "" }));
      }
    }
  }, [dateValStart]);

  console.log(formValues.eta_date);
  useEffect(() => {
    if (mounted) {
      if (dateValEnd) {
        setFormValues((prevValues) => ({
          ...prevValues,
          endDate: dateValEnd,
        }));
        setFormErrors((prevErrors) => ({ ...prevErrors, endDate: "" }));
      }
    }
  }, [dateValEnd]);

  return (
    <Container ref={myRef}>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
      {Loadingdata ? (
        <>
          <div className="d-flex" style={{ minHeight: "calc(100vh - 17rem)" }}>
            <Loading />
          </div>
        </>
      ) : (
        <Row className="justify-content-center gy-0 mb-6rem row new-datepicker">
          <Col xl="21" xxl="18">
            <h1 className="lh-base mb-4">Add a new To-do</h1>
            <section className="bg-white p-4 p-md-6 p-lg-8 shadow rounded-4">
              <Form onSubmit={handleSubmit} encType="multipart/form-data">
                <h2 className="mb-1 mb-md-2">Details</h2>
                <p className="mb-4">
                  Add your To-Dos – anything that needs doing. Schedule when and
                  how often, and assign tasks to anyone in your group –
                  including yourself
                </p>
                <Row className="gy-0 mb-4">
                  <Col md="12" lg="12">
                    <Form.Label
                      className={formErrors.task_name ? "text-danger" : " "}
                    >
                      Name
                    </Form.Label>
                    <Form.Control
                      className={formErrors.task_name ? "is-invalid" : ""}
                      type="text"
                      placeholder="e.g. Pick up my prescription​"
                      name="task_name"
                      value={formValues.task_name}
                      onChange={handleChange}
                      maxLength={255}
                    />
                    <Form.Text
                      className={formErrors.task_name ? "text-danger" : " "}
                    >
                      Give your To-Do a name, like 'Pick up my prescription’
                    </Form.Text>
                  </Col>
                </Row>
                <Row className="gy-0 mb-4">
                  <Col xs="24">
                    <Form.Label>
                      Description
                      <span className="small text-muted fw-normal ms-1">
                        Optional
                      </span>
                    </Form.Label>
                    <Form.Control
                      className={formErrors.task_details ? "is-invalid" : ""}
                      as="textarea"
                      rows={4}
                      cols={5}
                      name="task_details"
                      value={formValues.task_details}
                      onChange={handleChange}
                      placeholder="For example, please pick up my prescriptions from Jills Pharmacy. (You could also put the address) ​"
                      maxLength={255}
                    />
                    <Form.Text>
                      What you intend to do or what you need a support user to
                      do for you.
                    </Form.Text>
                  </Col>
                </Row>
                <Row className="gy-0 mb-4">
                  <Col md="16" lg="12">
                    <Form.Label
                      className={formErrors.eta_date ? "text-danger" : " "}
                    >
                      Date
                    </Form.Label>
                    <InputGroup
                      className={formErrors.eta_date ? "is-invalid" : ""}
                    >
                      <DateTimePicker
                        onChange={setDateValStart}
                        name="eta_date"
                        value={dateValStart ? new Date(dateValStart) : null} // Ensure Date object
                        format="dd-MM-yyyy h:mm a" // Format for date & time
                        dayPlaceholder="dd"
                        monthPlaceholder="mm"
                        yearPlaceholder="yyyy"
                        clearIcon={null} // Hide clear button
                        className={`${
                          formErrors.eta_date ? "invalid-border-right" : ""
                        } form-control`}
                        disableClock={true} // Hide clock for time input
                        minDate={new Date()} // Prevent past dates
                      />
                    </InputGroup>
                    <Form.Text
                      className={formErrors.eta_date ? "text-danger" : " "}
                    >
                      Please select the date before which the to-do has to be
                      completed
                    </Form.Text>
                  </Col>
                </Row>
                <Row className="gy-0 mb-4">
                  <Col md="24">
                    <Form.Label className="mb-0">Recurring</Form.Label>
                    <p className="mb-2">
                      Do you want this task to repeat regularly?
                    </p>
                    <Form.Switch
                      className={formErrors.date ? "is-invalid" : ""}
                      onChange={onSwitchAction}
                      checked={isSwitchOn}
                    />
                  </Col>
                </Row>
                {isSwitchOn && (
                  <Row className="gy-4 gx-md-4 gy-md-4 mb-4">
                    <Col md="10" lg="8">
                      <Form.Label
                        className={
                          formErrors.task_frequency ? "text-danger" : " "
                        }
                      >
                        Frequency
                      </Form.Label>

                      <Select
                        styles={
                          formErrors.task_frequency
                            ? customStylesError
                            : customStyles
                        }
                        options={frequencyOption}
                        defaultValue={{
                          label: "Select a frequency",
                          value: "",
                        }}
                        value={selectedTenure}
                        onChange={handleChange}
                        name="task_frequency"
                      />
                      <Form.Text
                        className={
                          formErrors.task_frequency ? "text-danger" : " "
                        }
                      >
                        Please select the frequency
                      </Form.Text>
                    </Col>
                    <Col md="10" lg="8">
                      <Form.Label>Enddate </Form.Label>
                      <InputGroup
                        className={formErrors.endDate ? "is-invalid" : ""}
                      >
                        <DatePicker
                          onChange={setDateValEnd}
                          name="date"
                          value={dateValEnd ? new Date(dateValEnd) : null} // Ensure Date object
                          format="dd-MM-yyyy" // Format for date & time
                          dayPlaceholder="dd"
                          monthPlaceholder="mm"
                          yearPlaceholder="yyyy"
                          minDate={dateValStart ? new Date(dateValStart) : null} // Use minDate instead of min
                          clearIcon={null} // Hide clear button
                          className={`${
                            formErrors.endDate ? "invalid-border-right" : ""
                          } form-control`}
                        />
                      </InputGroup>
                      <Form.Text
                        className={formErrors.endDate ? "text-danger" : " "}
                      >
                        Please select the end date
                      </Form.Text>
                    </Col>
                  </Row>
                )}
                <Row className="gy-0 mb-4">
                  <Col md="16" lg="12">
                    <Form.Label
                      className={formErrors.assignee ? "text-danger" : " "}
                    >
                      Assignee
                    </Form.Label>

                    <Select
                      styles={
                        formErrors.assignee ? customStylesError : customStyles
                      }
                      options={assigneeOption}
                      defaultValue={{
                        label: "select an assignee",
                        value: "",
                      }}
                      value={selectedAssignee}
                      onChange={handleChange}
                      name="assignee"
                    />
                    <Form.Text
                      className={formErrors.assignee ? "text-danger" : " "}
                    >
                      Who do you wish to do this task? This User will be called
                      your Assignee for this task.
                    </Form.Text>
                  </Col>
                </Row>
                <div className="d-flex justify-content-end">
                  <Button
                    className="d-flex align-items-center"
                    variant="primary"
                    type="submit"
                    isLoading={loading ? "true" : "false"}
                    isDisabled={loading ? "true" : "false"}
                  >
                    <i className="fa-solid fa-sm fa-add lh-1 align-middle me-2"></i>
                    Add to-do
                  </Button>
                </div>
              </Form>
            </section>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default TasksAdd;
